function doSearchScroll() {
  window.scrollTo({ top: this.$data.searchScrollPosition, behavior: 'auto' });
  this.$data.settings.loading = false;
}
export default doSearchScroll;
